import { useNavigate } from "react-router-dom";
import CardTitle from "../../components/styled/CardTitle";
import CardList from "../../components/styled/CardList";

export default function CarInformation({ data }) {
  const navigate = useNavigate();
  const car = data?.car;

  const handleView = () => {
    if (car?.sku) {
      navigate(`/stock-list/${car?.sku}/view`);
    }
  };

  const viewBtn = {
    cursor: "pointer",
    color: "var(--primary-text-color)",
    fontWeight: 500
  };

  return (
    <div className="card border-0">
      <div className="card-body">
        <CardTitle>Car Information</CardTitle>
        <CardList className="list-unstyled m-0">
          <li>
            <b>Chassis Number:</b>{" "}
            <span style={viewBtn} onClick={handleView}>
              {car?.chassis || "N/A"}
            </span>
          </li>
          <li>
            <b>Engine Number:</b> {car?.engine || "N/A"}
          </li>
          <li>
            <b>BRTA Reg.:</b> {car?.brta_reg || "N/A"}
          </li>
          <li>
            <b>Vehicle Name:</b> {car?.name || "N/A"}
          </li>
          <li>
            <b>Fuel:</b> {car?.fuel || "N/A"}
          </li>
          <li>
            <b>Color:</b> {car?.color || "N/A"}
          </li>
          <li>
            <b>CC:</b> {car?.cc || "N/A"}
          </li>
          <li>
            <b>Year:</b> {car?.year || "N/A"}
          </li>
          <li>
            <b>Descriptions:</b> {car?.descriptions || "N/A"}
          </li>
        </CardList>
      </div>
    </div>
  );
}
